<template>
  <div v-if="reminds.data.length" class="payment-account-recurring">
    <h4 class="payment-account-recurring__title">
      <BaseSvg name="ico-calendar-3"/>
      <span>{{$tPayment('Payment reminder')}}:</span>
    </h4>

    <div v-for="item in reminds.data" :key="item" class="payment-account-recurring__item">
      <time class="payment-account-recurring__item-time">
        {{$tPayment('Next reminder')}}: {{ item.next }}
      </time>
      <div class="payment-account-recurring__item-value">
        {{ item.transactionAmount }} {{ item.transactionCurrencyCode }}
      </div>
      <!--<div class="payment-account-recurring__item-direction">
        Satchel Рау → Акккордбанк
      </div>-->
      <button @click="removeRemind(item.id)" class="payment-account-recurring__cancel-btn  base-btn  base-btn--red">
        <BaseSvg name="ico-trash" width="1.4rem" height="1.6rem"/>
        <span>{{$tPayment('Cancel reminders')}}</span>
      </button>
    </div>

  </div>
</template>

<script>
  import {http} from '@/axios'

  export default {
    name: 'PaymentAccountRecurringPayments',
    props:{
      reminds: [Array, Object],
    },
    data() {
      return {

      }
    },
    methods: {
      removeRemind(id){
        http.get('/api/jobian-pay/remove-jobian-pay-remind?id='+id)
                .then(() => {
                  this.update()
                })
      },
      update(){
         http.get('/api/jobian-pay/get-jobian-pay-reminds')
            .then(({data}) => {
              this.reminds = data
            })
      }
    }
  }
</script>

<style lang="less">

</style>
